import { Dispatch, SetStateAction } from 'react'
import { Linking, Share } from 'react-native'

import { UseMutateFunction } from '@tanstack/react-query'
import { publishEvent } from '@zet/analytics'
import { MY_TEAMS_ADVISOR } from '@zet/constants'
import { APP_NAME } from '@zet/end-points'
import { UserContext } from '@zet/feature-user/api/user/types'
import { i18n } from '@zet/localization'
import { AxiosResponse } from 'axios'
import * as FileSystem from 'expo-file-system'
import * as ImagePicker from 'expo-image-picker'

export function handleShare(link: string, agentName: string) {
  const res = Share.share({
    message: i18n.t('agentWebsite.shareLinkText', { link, agentName }),
  })
}
export function handleCopyToClipboard(websiteURL: string) {
  if (APP_NAME !== MY_TEAMS_ADVISOR) {
    import('@react-native-clipboard/clipboard')
      .then(({ default: Clipboard }) => {
        Clipboard?.setString(websiteURL.toString())
      })
      .catch((e) => {
        console.log(e, 'error in copying')
      })
  }
}

export function handleGrowSectionSubtext(
  userContext: UserContext,
  count: number
) {
  if (!userContext?.agentWebsiteUrl) {
    return i18n.t('agentWebsite.yourPersonal')
  } else if (count) {
    return i18n.t('agentWebsite.youHave', {
      enquiries: count,
    })
  } else {
    return i18n.t('agentWebsite.shareYour')
  }
}

export function handleGrowSectionText(userContext: UserContext) {
  if (userContext?.agentWebsiteUrl) {
    return i18n.t('agentWebsite.myWebsite')
  } else return i18n.t('agentWebsite.create')
}

export function handleGrowSectionNavigation(userContext: UserContext) {
  if (userContext?.agentWebsiteUrl) {
    return 'AgentWebsiteDashboard'
  } else return 'AgentWebsiteInfoScreen'
}

const PostImage = (result: any, mutate: any) => {
  const localUri = result.assets[0].uri
  const filename = localUri.split('/').pop()
  const match = /\.(\w+)$/.exec(filename)
  const type = match ? `image/${match[1]}` : `image`

  const formData = new FormData()
  formData.append('userProfilePic', {
    uri: localUri,
    name: filename,
    type,
  })
  mutate(formData)
}

export async function clickImage(
  setImage: Dispatch<SetStateAction<string | null>>,
  mutate: UseMutateFunction<AxiosResponse<any, any>, unknown, any, unknown>
) {
  try {
    const result = await ImagePicker.launchCameraAsync()

    if (!result.canceled) {
      setImage(result.assets[0].uri)
      PostImage(result, mutate)
    }
  } catch (error) {
    console.log('error', error)
  }
}
const getFileInfo = async (fileURI: string) => {
  const fileInfo = await FileSystem.getInfoAsync(fileURI)
  return fileInfo
}

const isLessThanTheMB = (fileSize: number, smallerThanSizeMB: number) => {
  const isOk = fileSize / 1024 / 1024 < smallerThanSizeMB
  return isOk
}
export async function pickImage(
  setImage: Dispatch<SetStateAction<string | null>>,
  mutate: UseMutateFunction<AxiosResponse<any, any>, unknown, any, unknown>
) {
  const result = await ImagePicker.launchImageLibraryAsync({
    mediaTypes: ImagePicker.MediaTypeOptions.Images,
    allowsEditing: true,
    aspect: [4, 3],
    quality: 1,
  })
  if (result.canceled) return

  const fileInfo = await getFileInfo(result?.assets?.[0]?.uri)
  const isLtGivenMB = isLessThanTheMB(fileInfo?.size, 2.5)
  if (!isLtGivenMB) {
    alert(`Image size must be smaller than 2.5MB!`)
    return
  } else {
    setImage(result?.assets[0]?.uri)
    PostImage(result, mutate)
  }
}
export function openUrlInBrowser(url: string, toast: any) {
  Linking.canOpenURL(url).then((supported) => {
    if (supported) {
      Linking.openURL(url)
    } else {
      toast?.show({
        intent: 'error',
        hideAfter: 2000,
        heading: 'There is some error while opening the link',
      })
    }
  })
}
export function handleCallPress(phoneNumber: string | undefined) {
  publishEvent('click_action', {
    item_name: 'agent-website-getintouch-call',
  })
  Linking.openURL(`tel:${phoneNumber}`)
}

export function handleWhatsappPress(phoneNumber: string | undefined) {
  publishEvent('click_action', {
    item_name: 'agent-website-getintouch-whatsapp',
  })
  Linking.openURL(`https://api.whatsapp.com/send?phone=+91${phoneNumber}`)
}
